import {
  Box,
  Typography,
  Grid,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReadableText from '../../../../components/text/ReadableText';

const PronunciationSection = ({ homographs }) => {
  const theme = useTheme();

  if (!homographs || homographs.length === 0) return null;

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle2" color="primary" gutterBottom>
        Pronunciations
      </Typography>
      <Box sx={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}>
        {homographs.map((homograph, index) => (
          <Box 
            key={index}
            sx={{ 
              p: 2,
              bgcolor: alpha(theme.palette.primary.main, 0.05),
              borderRadius: 1,
              border: '1px solid',
              borderColor: alpha(theme.palette.primary.main, 0.2),
              fontSize: '1.2rem'
            }}
          >
            <ReadableText text={homograph} />
            <Typography variant="caption" sx={{ 
              display: 'block', 
              mt: 1, 
              color: theme.palette.text.secondary 
            }}>
              Pronunciation {index + 1}
            </Typography>
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

export default PronunciationSection;